import { CheckCircle2, X } from 'lucide-react';
import { ReactNode } from 'react';

interface SuccessModalProps {
  title: string;
  message: string;
  buttonText?: string;
  onClose: () => void;
  icon?: ReactNode;
}

export function SuccessModal({ 
  title, 
  message, 
  buttonText = 'Great!',
  onClose,
  icon
}: SuccessModalProps) {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full p-6 sm:p-8 animate-in fade-in zoom-in duration-200 relative">
        {/* Close button (X) */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
        >
          <X className="h-5 w-5" />
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="bg-green-100 dark:bg-green-900/30 rounded-full p-4">
            {icon || <CheckCircle2 className="h-8 w-8 text-green-600 dark:text-green-400" />}
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-center text-gray-900 dark:text-white mb-2">
          {title}
        </h2>

        {/* Message */}
        <p className="text-center text-gray-600 dark:text-gray-400 mb-8 whitespace-pre-line">
          {message}
        </p>

        {/* Action */}
        <button
          onClick={onClose}
          className="w-full px-6 py-3 rounded-lg bg-green-600 hover:bg-green-700 text-white font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}
